import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectorRef, OnDestroy, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { WaitingDialogService } from '../../waitingDialog/waitingDialog.service';
import { ArchivoListar } from '../../../class/archivo.inteface';
import { ListaArchivosService } from '../lista-archivos.service';
import { AppModule } from '../../../../app-module';
import { LoaderComponent } from '../../loader/loader.component';


export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}

@Component({
  selector: 'oaj-modal-visualiza-archivos-itx',
  templateUrl: './modal-visualiza-archivos.component.html',
  styleUrls: ['./modal-visualiza-archivos.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [WaitingDialogService, ListaArchivosService],
  imports: [AppModule, LoaderComponent]

})

export class ModalVisualizaArchivosComponent implements OnInit, OnDestroy {
  listaAr: ArchivoListar[] = [];
  @Input()
  IdDocumento!: string;
  @Input()
  mimeType!: string;
  @Input()
  NombreSistema!: string;
  @Input()
  downloadFile = false;
  @Input()
  isAcuerdoSISE = false;
  @Input()
  extOriginal!: number;
  @Input() downloagOrg = false;
  @Input() isLaboral = false;

  urlSafe!: SafeResourceUrl;
  urlBlob!: Blob;
  isImage = false;
  base64str = '';
  loading = false;
  failed = false;
  errorMensaje!: string;
  lstSubscriptions: Subscription[] = [];
  UrlDocto = '';

  sMensajeError = "Ocurrio un error al cargar la información ";


  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  public sanitizer: DomSanitizer = inject(DomSanitizer);
  private srvFiles: ListaArchivosService = inject(ListaArchivosService);
  private modal: NgbActiveModal = inject(NgbActiveModal);
  private waitingDialog: WaitingDialogService = inject(WaitingDialogService);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  ngOnInit() {
    if (!this.isAcuerdoSISE) {
      this.mostrarArchivo(this.IdDocumento);
    }
    else {
      if (!this.isLaboral) { //SOLO SISE
        this.mostrarDoctoAcuerdo(this.IdDocumento);
      }
      else { //SOLO SIGE
        this.mostrarDoctoAcuerdoLab(this.IdDocumento);
      }
    }
  }

  public accept() {
    this.activeModal.close(true);
  }

  public download() {
    this.loading = true;
    const fileExt = this.NombreSistema.split('.').pop();
    let isWordFile = false;
    if (fileExt == 'doc' || fileExt == 'docx' || fileExt == 'pdf') {
      isWordFile = true;
    }
    if (!isWordFile && this.base64str && this.base64str.length > 0) {
      this.loading = false;
      const binary = atob(this.base64str.replace(/\s/g, ''));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }

      // create the blob object with content-type "application/pdf"
      const blob = new Blob([view], { type: this.mimeType });

      // Guardado de Archivo
      saveAs(blob, this.NombreSistema);
      this.changeDetectorRef.detectChanges();
    }
    else {

      this.cancelOutstandingRequestsA();
      const subscription = this.srvFiles.getArchivo(this.IdDocumento, this.downloagOrg)
        .subscribe((response: any) => {

          const base64str: string = response.data.base64File;

          const binary = atob(base64str.replace(/\s/g, ''));
          const len = binary.length;
          const buffer = new ArrayBuffer(len);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          // create the blob object with content-type "application/pdf"
          const blob = new Blob([view], { type: this.mimeType });

          // Guardado de Archivo
          saveAs(blob, this.NombreSistema);
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        }, (error: any) => {
          //  console.log('*** Error al traer el catálogo *** ' + error.status);
          console.error(error);
          this.failed = true;
          this.loading = false;
          this.errorMensaje = 'Ocurrió un error, intente nuevamente.';
          this.changeDetectorRef.detectChanges();
          return;
        });
      this.lstSubscriptions.push(subscription);
    }

  }

  mostrarArchivo(idArchivo: string) {
    this.cancelOutstandingRequestsA();
    this.loading = true;
    const subscription = this.srvFiles.getArchivoPrevisualizacion(idArchivo)
      .subscribe((response: any) => {
        this.loading = false;
        this.base64str = response.data.base64File;

        const binary = atob(this.base64str.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }

        const fileExt = this.NombreSistema.split('.').pop();
        // console.log('fileExt:', fileExt);

        this.isImage = true;
        if (fileExt == 'doc' || fileExt == 'docx' || fileExt == 'pdf') {
          this.isImage = false;
        }

        this.urlBlob = new Blob([view], { type: this.mimeType });
        if (fileExt == 'doc' || fileExt == 'docx') {
          this.urlBlob = new Blob([view], { type: 'application/pdf' });
        }

        const url = window.URL.createObjectURL(this.urlBlob);
        this.UrlDocto = `${url}#toolbar=0`;
        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlToolbar);
        this.changeDetectorRef.detectChanges();
      }, (error: any) => {
        // console.log('*** Error al traer el catálogo *** ' + error.status);
        console.error(error);
        this.failed = true;
        this.loading = false;
        this.errorMensaje = 'Ocurrió un error, intente nuevamente.';
        return;
      });
    this.lstSubscriptions.push(subscription);
  }

  cerrar() {
    this.modal.close(undefined);
  }

  ngOnDestroy() {
    this.cancelOutstandingRequestsA();
  }

  cancelOutstandingRequestsA() {
    this.lstSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.lstSubscriptions = [];
  }

  public descargarArcuerdo() {
    this.loading = true;
    const fileExt = this.NombreSistema.split('.').pop();
    let isWordFile = false;
    if (fileExt == 'doc' || fileExt == 'docx' || fileExt == 'pdf') {
      isWordFile = true;
    }
    if (!isWordFile && this.base64str && this.base64str.length > 0) {
      this.loading = false;
      const binary = atob(this.base64str.replace(/\s/g, ''));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }

      // create the blob object with content-type "application/pdf"
      const blob = new Blob([view], { type: this.mimeType });
      const NombreOriginal = (this.NombreSistema.split('.').slice(0, -1).join('.'));
      // console.log('NombreOriginal:', NombreOriginal);
      // Guardado de Archivo
      saveAs(blob, NombreOriginal);
      this.changeDetectorRef.detectChanges();
    }
    else {

      this.cancelOutstandingRequestsA();
      const subscription = this.srvFiles.getArchivoAcuerdo(this.IdDocumento, this.extOriginal)
        .subscribe((response: any) => {

          const base64str: string = response.data.base64File;

          const binary = atob(base64str.replace(/\s/g, ''));
          const len = binary.length;
          const buffer = new ArrayBuffer(len);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          // create the blob object with content-type "application/pdf"
          const blob = new Blob([view], { type: this.mimeType });
          const NombreOriginal = (this.NombreSistema.split('.').slice(0, -1).join('.'));
          // console.log('NombreOriginal:', NombreOriginal);
          // Guardado de Archivo
          saveAs(blob, NombreOriginal);
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        }, (error: any) => {
          // console.log('*** Error al traer el catálogo *** ' + error.status);
          console.error(error);
          this.failed = true;
          this.loading = false;
          this.errorMensaje = 'Ocurrió un error, intente nuevamente.';
          this.changeDetectorRef.detectChanges();
          return;
        });
      this.lstSubscriptions.push(subscription);
    }

  }

  mostrarDoctoAcuerdo(idArchivo: string) {
    this.cancelOutstandingRequestsA();
    this.loading = true;
    const subscription = this.srvFiles.getAcuerdoPrevisualizacion(idArchivo, this.extOriginal)
      .subscribe((response: any) => {
        this.loading = false;
        this.base64str = response.data.base64File;

        const binary = atob(this.base64str.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }

        const fileExt = this.NombreSistema.split('.').pop();

        this.isImage = true;
        if (fileExt == 'doc' || fileExt == 'docx' || fileExt == 'pdf') {
          this.isImage = false;
        }

        this.urlBlob = new Blob([view], { type: this.mimeType });
        if (fileExt == 'doc' || fileExt == 'docx') {
          this.urlBlob = new Blob([view], { type: 'application/pdf' });
        }

        const url = window.URL.createObjectURL(this.urlBlob);
        this.UrlDocto = `${url}#toolbar=0`;
        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlToolbar);
        this.changeDetectorRef.detectChanges();
      }, (error: any) => {
        //  console.log('*** Error al traer el catálogo *** ' + error.status);
        console.error(error);
        this.failed = true;
        this.loading = false;
        this.errorMensaje = 'Ocurrió un error, intente nuevamente.';
        return;
      });
    this.lstSubscriptions.push(subscription);
  }

  mostrarDoctoAcuerdoLab(idArchivo: string) {
    this.cancelOutstandingRequestsA();
    this.loading = true;
    const subscription = this.srvFiles.getAcuerdoPrevisualizacionLab(idArchivo, this.extOriginal)
      .subscribe((response: any) => {
        this.loading = false;
        this.base64str = response.data.base64File;

        const binary = atob(this.base64str.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }

        const fileExt = this.NombreSistema.split('.').pop();

        this.isImage = true;
        if (fileExt == 'doc' || fileExt == 'docx' || fileExt == 'pdf') {
          this.isImage = false;
        }

        this.urlBlob = new Blob([view], { type: this.mimeType });
        if (fileExt == 'doc' || fileExt == 'docx') {
          this.urlBlob = new Blob([view], { type: 'application/pdf' });
        }

        const url = window.URL.createObjectURL(this.urlBlob);
        this.UrlDocto = `${url}#toolbar=0`;
        this.changeDetectorRef.detectChanges();
      }, (error: any) => {
        console.error(error);
        this.failed = true;
        this.loading = false;
        this.errorMensaje = 'Ocurrió un error, intente nuevamente.';
        return;
      });
    this.lstSubscriptions.push(subscription);
  }

}
